import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Text from 'components/Text';
import CommentForm from '../CommentForm';
import { CommentAvatarWrapper } from '../Shared';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FeedbackForm(_ref) {
  var onSubmit = _ref.onSubmit,
    userProfile = _ref.userProfile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('idle'),
    _useState2 = _slicedToArray(_useState, 2),
    submissionStatus = _useState2[0],
    setSubmissionStatus = _useState2[1];
  var handleOnSubmit = function handleOnSubmit(message) {
    return onSubmit({
      message: message
    }).then(function () {
      return setSubmissionStatus('success');
    }).catch(function (err) {
      setSubmissionStatus('error');
      return Promise.reject(err); // pass the error on so the form doesn't empty the input field
    });
  };
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "m",
    p: "m",
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        size: "small",
        children: t('asset_feedback_title')
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        size: "s",
        children: t('asset_feedback_description')
      })]
    }), /*#__PURE__*/_jsx(CommentAvatarWrapper, {
      pictureUrl: userProfile === null || userProfile === void 0 ? void 0 : userProfile.pictureUrl,
      children: /*#__PURE__*/_jsx(CommentForm, {
        inputLabel: t('asset_feedback_your_message'),
        submitButtonLabel: t('actions_submit'),
        submitSuccessMessage: t('alert_feedback_success'),
        submissionStatus: submissionStatus,
        onResetSubmitStatus: function onResetSubmitStatus() {
          return setSubmissionStatus('idle');
        },
        onSubmit: handleOnSubmit
      })
    })]
  });
}
export default FeedbackForm;